import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  statusType: {
    description: '',
    code: '',
    statusType: '',
  },
};

export const createStatusType = createSlice({
  name: 'createStatusType',
  initialState,
  reducers: {
    updateStatusTypeInfo: (state, action) => {
      state.statusType = action.payload;
    },
    updateStatusTypeInfoField: (state, action) => {
      const { field, value } = action.payload;
      state.statusType[field] = value;
    },
    clearStatusTypeInfo: (state) => {
      state.statusType = initialState.statusType;
    },
  },
});
export const statusTypeDetailSelector = (state) =>
  state.createStatusType.statusType;
export const {
  updateStatusTypeInfo,
  updateStatusTypeInfoField,
  clearStatusTypeInfo,
} = createStatusType.actions;
export const createStatusTypeReducer = createStatusType.reducer;
export const createStatusTypeReducerName = createStatusType.name;

export default createStatusType.reducer;
